import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getMaterialsWithPublishStatus,
  unPublishMaterial,
  saveMaterialAccess
} from './api'
import { Material, InitialState, SelectedMaterial } from './types'

const initialState: InitialState = {
  isLoading: false,
  materials: []
}

export const materialSlice = createSlice({
  name: 'material',
  initialState,
  reducers: {
    selectedMaterial: (
      state,
      action: PayloadAction<SelectedMaterial | null>
    ) => {
      state.selectedMaterial = action?.payload
    },
    resetMaterial: (state) => {
      state.materials = []
    }
  },
  extraReducers: {
    [getMaterialsWithPublishStatus.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getMaterialsWithPublishStatus.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Material>>
    ) => {
      state.isLoading = false
      state.materials = action?.payload
    },
    [getMaterialsWithPublishStatus.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [unPublishMaterial.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [unPublishMaterial.fulfilled.toString()]: (state) => {
      state.isLoading = false
      state.materials = []
    },
    [unPublishMaterial.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [saveMaterialAccess.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [saveMaterialAccess.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [saveMaterialAccess.rejected.toString()]: (state) => {
      state.isLoading = false
    }
  }
})

export default materialSlice.reducer
